// Filename: collections/activitys
define('collections/calendar/session/renamed-animations',[
    'underscore',
    'backbone',
    'mustache',
    'moment',
    'utils',
    // super class
    'src/plugins/infinite-collection',
    // services
    'services/api',
    // models
    'models/calendar/session/renamed-animation'
], function(
    // libs
    _, Backbone, Mustache, moment, U,
    // super class
    InfiniteCollection,
    // services
    API,
    // model
    MRenamedAnimation
) {

    var CRenamedAnimations = Backbone.Collection.extend({
        model: MRenamedAnimation,
        url: function() {
            var url = "exercises/renamed/";
            url = "groups/" + this.group + "/" + url;

            return API.url(url);
        },

        initialize: function(models, opt) {
            opt = opt || {};
            this.setGroup(opt.group);
        },

        setGroup: function(groupId) {
            this.group = groupId;
        },

        getStringNames: function() {
            var names = "",
                isLast = false,
                cpt = 1;

            this.every(function(model, i) {
                isLast = i === this.length - 1;
                names += model.get('name');
                cpt++;

                if (this.length <= 4 && isLast) {
                    names += "";
                } else {
                    names += isLast || i === 4 ? "..." : ", ";
                }

                return i !== 4;
            }, this);

            return names;
        },

    });

    return CRenamedAnimations;
});

